import { render, staticRenderFns } from "./UsersStats.vue?vue&type=template&id=37de13d0&scoped=true&"
import script from "./UsersStats.vue?vue&type=script&lang=js&"
export * from "./UsersStats.vue?vue&type=script&lang=js&"
import style0 from "./UsersStats.vue?vue&type=style&index=0&id=37de13d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de13d0",
  null
  
)

export default component.exports